import { render, staticRenderFns } from "./email-edit-form.vue?vue&type=template&id=49fa31e5&"
import script from "./email-edit-form.vue?vue&type=script&lang=js&"
export * from "./email-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./email-edit-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fa31e5')) {
      api.createRecord('49fa31e5', component.options)
    } else {
      api.reload('49fa31e5', component.options)
    }
    module.hot.accept("./email-edit-form.vue?vue&type=template&id=49fa31e5&", function () {
      api.rerender('49fa31e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/email-edit-form.vue"
export default component.exports